<template>
    <div 
        class="w-100 d-flex justify-content-between align-items-center flex-wrap rfx-wizard-top-bar"
    >
        <div class="w-50 d-flex align-items-center my-2">
            <!-- <b-badge v-if="stepNumber" pill variant="primary" class="font-size-100 mr-3">{{ stepNumber }}</b-badge> -->
            <number-round v-if="stepNumber" :text="stepNumber" variant="primary" class="mr-3"></number-round>
            <b-icon :icon="icon"></b-icon>
            <div>
                <h4 class=""> 
                    {{ title }}
                </h4>
                <p class="mb-0">{{ description }}</p>
            </div>
        </div>
        <div class="d-flex justify-content-center border rounded-pill shadow overflow-hidden my-2 ml-auto">
            <div v-if="!hidePrevious" class="h-100" style="border-right: 1px solid var(--gray-300)">
                <b-button 
                    :disabled="disabledPrevious" 
                    variant="white-secondary" 
                    size="lg" 
                    class="text-nowrap rounded-0"
                    @click="$emit('previous')"
                >
                    <div class="d-flex align-items-center">
                        <b-icon icon="chevron-double-left" class="mr-2"></b-icon>
                        <div class="text-nowrap">
                            Previous
                        </div>
                    </div>
                </b-button>
            </div>
            <div v-if="!hideSave" class="h-100" style="border-right: 1px solid var(--gray-300)">
                <b-button 
                    :disabled="disabledSave" 
                    variant="white-primary" 
                    size="lg" 
                    class="text-nowrap rounded-0"
                    @click="$emit('save')"
                >
                    Save
                </b-button>
            </div>
            <div v-if="!hideNext" class="h-100">
                <b-button 
                    :disabled="disabledNext" 
                    variant="white-success" 
                    size="lg" 
                    class="text-nowrap rounded-0"
                    @click="$emit('next')"
                >
                    <div class="d-flex align-items-center">
                        <div class="text-nowrap">
                            Save & Next
                        </div>
                        <b-icon icon="chevron-double-right" class="ml-2"></b-icon>
                    </div>                    
                </b-button>
            </div>
        </div>
        <!-- <b-button-group size="lg" class="overflow-hidden rounded-pill border">
            <b-button variant="sharp-secondary" class="text-nowrap">&larr; Previous</b-button>
            <b-button variant="sharp-primary" class="text-nowrap">Save</b-button>
            <b-button variant="sharp-success" class="text-nowrap">Save & Next &rarr;</b-button>
        </b-button-group> -->
    </div>
</template>

<script>
import NumberRound from './functional-comps/NumberRound';

export default {
    name: 'RfxWizardTopBar',
    components: {
        NumberRound,
    },
    props: {
        title: {
            type: String,
        },
        description: {
            type: String,
            required: false,
        },
        stepNumber: {  // stepNumber takes priority over icon, share same space
            type: [String, Number],
            required: false,
        },
        icon: {
            type: String,
            required: false,
        },
        hideNext: {
            type: Boolean,
            default: false,
        },
        hidePrevious: {
            type: Boolean,
            default: false,
        },
        hideSave: {
            type: Boolean,
            default: false,
        },
        disabledNext: {
            type: Boolean,
            default: false,
        },
        disabledPrevious: {
            type: Boolean,
            default: false,
        },
        disabledSave: {
            type: Boolean,
            default: false,
        }
    },
}
</script>

<style>

</style>